const deleteThreadEvent = ({ threadId, eventId } = {}) => {
  return {
    type: 'pieveDeleteThreadEvent',
    payload: { threadId, eventId }
  };
};

export default deleteThreadEvent;
